import React from 'react';
import '../App.css';
import './HeroSection.css';
import Livestream from './Livestream';


function HeroSection() {


  return (
    <div className='hero-container'>
        <h1>Presidential Broadcast Service </h1>
        <p>Radio Portal</p>
        <div className='hero-btns'>
            {/* <Button className='btns' buttonStyle='btn--outline' buttonSize='btn--large'>Get Started</Button> */}

            {/* <Button className='btns' buttonStyle='btn--primary' buttonSize='btn--large'>Watch Livestream<i className='far fa-play-circle'/></Button> */}
{/*
            <button type = "button" className='livestreambtn'>Watch Livestream<i className='far fa-play-circle'/></button> */}
            {/* <Livestream path = 'http://localhost:3003/login'/> */}
            {/* <Livestream target={'_blank'} path = 'http://58.97.187.52:8000/rp3'></Livestream> */}


        </div>

    </div>
  )
}

export default HeroSection;